
<template>
  <v-dialog
      v-model="mapDialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay=false
      scrollable
    >
    <v-card>
      <v-toolbar style="flex: 0 0 auto;" dark class="primary">
        <v-btn icon @click.native="closeModal" dark>
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Kaart</v-toolbar-title>
      </v-toolbar>
      <units-map :showMap="mapDialog"></units-map>
    </v-card>
  </v-dialog>
</template>
<script>
import * as utils from '@/utils/utils'  
import UnitsMap from '@/components/Units/UnitsMap'
export default {
  name: 'MapModal',
  components: { UnitsMap },
  props: [ 'mapDialog' ],
  data() {
    return {
      
      }
  },
  created() {
   
  },
  methods: {
    closeModal() {
      window.emitter.$emit('closeMap');
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/MapModal.vue